import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Cascader, Tabs } from 'antd'
import shallow from 'zustand/shallow'
import { Country } from '../../types'
import { PerTabBarContent } from '../../components/custom_components/TabBarContent'
import { usePyramidsStore, PyramidTabs } from './PyramidsStore'
import { searchOptionsFilter } from '../../components/custom_components/Cascader/util'
import { useCascaderSearchOnOpen } from '../../components/custom_components/Cascader/useCascaderSearchOnOpen'

const { TabPane } = Tabs

export const PyramidsHeader: FC = () => {
  const { t } = useTranslation()

  const [activeTab, setActiveTab, newtworksWithCompanyAndCountriesSelection, selected, setSelected, isAgePyramidVisible] = usePyramidsStore(
    (state) => [
      state.activeTab,
      state.setActiveTab,
      state.newtworksWithCompanyAndCountriesSelection,
      state.selected,
      state.setSelected,
      state.isAgePyramidVisible,
    ],
    shallow,
  )

  const { cascaderRef, cascaderClassName, searchPlaceholder, onPopupVisibleChange } = useCascaderSearchOnOpen(
    t('pyramidsView.networkCompanyCountryCascaderSearchPlaceholder'),
  )

  const onDropDownChanged = (value: string[]) => {
    if (value && value.length === 3) {
      setSelected(value[0], value[1], value[2] as Country)
      setActiveTab(PyramidTabs.Level)
    }
  }

  return (
    <PerTabBarContent
      tabs={
        <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key as PyramidTabs)}>
          <TabPane tab={t('pyramidsView.type.Level')} key={PyramidTabs.Level} />
          {isAgePyramidVisible && <TabPane tab={t('pyramidsView.type.Age')} key={PyramidTabs.Age} />}
        </Tabs>
      }
      actions={
        <Cascader
          ref={cascaderRef}
          className={cascaderClassName}
          options={newtworksWithCompanyAndCountriesSelection}
          onChange={onDropDownChanged}
          placeholder={searchPlaceholder}
          allowClear={false}
          defaultValue={[selected.networkId, selected.companyId, selected.country]}
          value={[selected.networkId, selected.companyId, selected.country]}
          style={{ width: '500px', marginLeft: '3.5px' }}
          showSearch={{ filter: searchOptionsFilter }}
          onPopupVisibleChange={onPopupVisibleChange}
        />
      }
    />
  )
}
